export default {
  app: {
    terms: {
      terms: 'Všeobecné obchodní podmínky',
      pageTitle: 'Všeobecné obchodní podmínky - Elixír Tours',
    },
  },
};
